import AB_TEST_PARAMS from '@signal/utils/ab-testing'
import {
  AB_MENU_QP_STORAGE_KEY,
  AB_REPORT_SCHEDULER,
  AB_MAP_COMPARISON_MODE
} from './constants'

export function carryParameters() {
  return AB_TEST_PARAMS[AB_MENU_QP_STORAGE_KEY]
}

export function showReportScheduler() {
  return AB_TEST_PARAMS[AB_REPORT_SCHEDULER]
}

export function enableMapComparisonMode() {
  return AB_TEST_PARAMS[AB_MAP_COMPARISON_MODE]
}
